import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@paypalcorp/pp-react';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_cancel_return__C8ymo {\n  color: #1072eb;\n}\n";
var styles = {"cancel_return":"styles-module_cancel_return__C8ymo"};
styleInject(css_248z);

var CancelAndReturnUrl = function CancelAndReturnUrl(_ref) {
  var content = _ref.content,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onClick: onClick,
    className: styles.cancel_return
  }, content));
};
CancelAndReturnUrl.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func
};

export { CancelAndReturnUrl };
